import { createContext, useContext } from 'react';

export const SceneMenuContext = createContext({
  activeReplacement: null as string | null,

  activateReplacement: (id: string) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
  deactivateReplacement: () => {},

  containerEl: null as HTMLDivElement | null,
});

export function useSceneMenuContext() {
  return useContext(SceneMenuContext);
}
